import React from "react";
import CheckboxBase, { ICheckboxBaseProps } from "../CheckboxBase";
import * as S from "./styled";

export type TRadioProps = Omit<
    ICheckboxBaseProps,
    "labelSize" | "labelColor" | "helperTextSize" | "type" | "renderIcon"
>;

const Radio: React.FC<TRadioProps> = ({ size = "sm", trackData, ...props }) => {
    return (
        <CheckboxBase
            type="radio"
            size={size}
            labelColor="text-primary-1200"
            labelSize={size === "sm" ? "label-small-medium" : "label-regular-medium"}
            helperTextSize={size === "sm" ? "label-small-regular" : "label-regular-regular"}
            renderIcon={() => <S.Radio />}
            trackData={trackData}
            {...props}
        />
    );
};

export default Radio;
